import gql from 'graphql-tag';

export const GET_USER_ACCOUNT = gql`
	query get_user_account {
		user {
			user_id
			email
			language
			role
			mfa_enabled
			mfa_phone_e164
			rewards_referrals {
				asset_id
				type
				paid
				pending
				blocked
				amount
				completed
				expired
				id
				promotional_referral
			}
			promotional_referral {
				promotional_referral
				rewards_referrals {
					id
					type
					amount
					created_at
					user_id
					completed
					expired
					paid
					pending
					blocked
					asset_id
					request_payment {
						status
					}
				}
			}
			personalInformations {
				countryOrigin
				email
				firstName
				firstname_validated
				lastName
				lastname_validated
				withholding
				type
				status_aml
				pbc_economic_activity
			}
			kycs {
				id
				status
				step
				kyc_data
			}
		}

		accounts(where: { type: { _in: [account_internal_wallet_web3, account_internal_wallet_web2] } }) {
			type
			account_internal_wallet_web3 {
				address
			}
			account_internal_wallet_web2 {
				accountId
			}
			balances {
				amount {
					currency
					value
				}
			}
		}
	}
`;

export const INSERT_REFERRAL = gql`
	mutation insertRewardsReferral($object: rewards_referral_insert_input = {}) {
		insert_rewards_referral_one(object: $object) {
			id
		}
	}
`;

export const UPDATE_LANGUAGE = gql`
	mutation updateUserLanguage($user_id: uuid!, $language: String!) {
		update_user(where: { user_id: { _eq: $user_id } }, _set: { language: $language }) {
			affected_rows
		}
	}
`;
